import { Component, input } from '@angular/core';
import { WorkTicketStatusChange } from '@work-frontend-monorepo/work-rest-api';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { AvatarComponent } from '../avatar/avatar.component';
import { FormatDatePipe } from '../../pipes/format-date.pipe';
import { PrependServerToFileSrcPipe } from '../../pipes/prepend-server-to-file-src.pipe';
import { GetTicketStatusColorVariantPipe } from '../../pipes/get-ticket-status-color-variant.pipe';
import { BadgeComponent } from '../badge/badge.component';

@Component({
  selector: 'work-ui-timeline-ticket-status-change-item',
  templateUrl: './timeline-ticket-status-change-item.component.html',
  styleUrls: ['./timeline-ticket-status-change-item.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    TranslateModule,
    FormatDatePipe,
    AvatarComponent,
    PrependServerToFileSrcPipe,
    GetTicketStatusColorVariantPipe,
    BadgeComponent,
  ],
})
export class TimelineTicketStatusChangeItemComponent {
  ticketStatusChange = input.required<WorkTicketStatusChange>();
  tableStyle = input<boolean>(false);
}
